
import api from "../../api"
import attrs_all from "../../api/attrs"
import simple_component from "./components/simple"

// TODO default значения

const labels = {

	"matchType" : "Логический оператор",
	"matchTypes" : 
	[
		{"id": "all", "label": "И"},
		{"id": "any", "label": "ИЛИ"},
		{"id": "not_all", "label": "Ни один из"},
	],
	"addRule": "Добавить условие",
	"removeRule": "Удалить условие",
	"addGroup": "Добавить логический оператор",
	"removeGroup": "Удалить логический оператор",
	"textInputPlaceholder": "Значение",

}

function create_rules(self, essence, attrs, additional_rules = [])
{
	var rules = []
	var promises =
	[
		api.call(self, "filters", "get_many", { query : { essence : essence }, is_raw : true },
			response => 
			{
				var filters = []

				response.data.forEach(
					filter =>
						filters.push(
							{
								label : filter.name,
								value : filter.id
							})
					)

				if(filters.length)
					rules.push(
						{
							id : "filter",
							label : "Фильтр",
							type : "select",
							keys : [ "filter" ], 
							operators : [ "=" ],
							operations : { "=" : "filter" },
							choices : filters
						})
			})
	]

	additional_rules.forEach(rule => rules.push(rule))

	rules.push(
		{
			id : "cadastral_group",
			label : "Группа",
			type : "custom-component",
			keys : "cadastral_group",
			component : simple_component,
			operations : { "cadastral_group" : "cadastral_group" },
			operators : [ "cadastral_group" ],
			default : null,
			unable_to_add : true
		})

	rules.push(
		{
			id : "cadastral_group_exactly",
			label : "Группа (только в данной группе)",
			type : "custom-component",
			keys : "cadastral_group_exactly",
			component : simple_component,
			operations : { "cadastral_group_exactly" : "cadastral_group_exactly" },
			operators : [ "cadastral_group_exactly" ],
			default : null,
			unable_to_add : true
		})

	rules.push(
		{
			id : "cadastral_group_children",
			label : "Группа (только в дочерних группах)",
			type : "custom-component",
			keys : "cadastral_group_children",
			component : simple_component,
			operations : { "cadastral_group_children" : "cadastral_group_children" },
			operators : [ "cadastral_group_children" ],
			default : null,
			unable_to_add : true
		})

	rules.push(
		{
			id : "cadastral_group_right",
			label : "Группа (разгруппированы в расчетную группу)",
			type : "custom-component",
			keys : "cadastral_group_right",
			component : simple_component,
			operations : { "cadastral_group_right" : "cadastral_group_right" },
			operators : [ "cadastral_group_right" ],
			default : null,
			unable_to_add : true
		})

	rules.push(
		{
			id : "cadastral_group_bad",
			label : "Группа (не разгруппированы в расчетную группу)",
			type : "custom-component",
			keys : "cadastral_group_bad",
			component : simple_component,
			operations : { "cadastral_group_bad" : "cadastral_group_bad" },
			operators : [ "cadastral_group_bad" ],
			default : null,
			unable_to_add : true
		})

	attrs.filter(attr => attr.attr_key || attr.in_query).forEach(
		attr =>
		{
			var promise

			if(attr.attr_key)
				promise = attrs_all.get(self)
					.then(
						attrs =>
						{
							var _attr = api.deep_clone(attrs.attrs.find(_attr => _attr.key == attr.attr_key))

							if(attr.label)
								delete _attr.label

							attr = Object.assign(attr, _attr)
							attr.key = "current_version." + attr.key
						})
			else
				promise = new Promise(resolve => resolve())

			promises.push(
				promise.then(
					() =>
					{
						var rule = {

							id : attr.key,
							label : attr.label,
							reference : attr.reference == null ? null : attr.reference.id,

						}

						if(attr.keys_for_query == null)
							rule.keys = [ attr.key ]
						else
							rule.keys = attr.keys_for_query

						if(attr.type == "bool")
						{
							rule.type = "radio"

							if(attr.bool_reverse)
								rule.choices = [ { label : "Да", value : false }, { label : "Нет", value : true }, { label : "Значение отсутствует", value : "empty" } ]
							else
								rule.choices = [ { label : "Да", value : true }, { label : "Нет", value : false }, { label : "Значение отсутствует", value : "empty" } ]

							rule.operations = { "execute" : "eq" }
						}
						else if(attr.type == "array")
						{
							rule.type = "text"

							rule.operations = {
								"пусто" : "array_empty",
								"не пусто" : "array_notempty",
								"содержит" : "contain",
								"не содержит" : "not_contain",
								"начинается с" : "begin_with",
								"заканчивается на" : "end_on",
							}
						}
						else
						{
							rule.operations = {
								"пусто" : "empty",
								"не пусто" : "notempty",
							}

							if(attr.type == "str")
							{
								var without_complex_operations = false

								if(attr.reference)
								{
									rule.type = "select"
									rule.choices = []

									var simple_values = attr.reference.simple_values

									if(simple_values)
									{
										simple_values = api.sort_objects_array_by_key(simple_values, "label")
										simple_values.forEach(elem => rule.choices.push(elem)) // label, value
									}
									else if(attr.reference.values)
										attr.reference.values.forEach(elem => rule.choices.push({ label : api.format_reference(attr.reference, elem), value : elem }))
									else if(attr.reference.service)
										api.call(self, attr.reference.service, "get_reference", { reference : attr.reference.name },
											response => response.reference.forEach(
												elem =>
												{
													if(attr.reference.except == null || attr.reference.except.indexOf(elem) < 0)
														rule.choices.push({ label : elem, value : elem })
												}))
									else
										attrs_all.get(self)
											.then(
												attrs =>
												{
													const key = attr.reference.attr_key
													var ref = attrs.attrs.find(attr => attr.key == key).reference

													if(ref)
													{
														attr.reference.original = ref.original
														ref.values.forEach(value => rule.choices.push({ label : api.format_reference(ref, value), value : value }))
													}
												})
								}
								else
									rule.type = "text"

								rule.operations["="] = "eqs"
								rule.operations["не равно"] = "nes"

								if(! without_complex_operations)
								{
									rule.operations["содержит"] = "contain"
									rule.operations["не содержит"] = "not_contain"
									rule.operations["регулярное выражение"] = "regexp"

									if(! attr.complex)
									{
										rule.operations["начинается с"] = "begin_with"
										rule.operations["заканчивается на"] = "end_on"
									}
								}
							}
							else if(attr.type == "number")
							{
								rule.type = "numeric"

								rule.operations["="] = "eq"
								rule.operations["не равно"] = "ne"
								rule.operations["<"] = "lt"
								rule.operations[">"] = "gt"
								rule.operations["<="] = "lte"
								rule.operations[">="] = "gte"
							}
							else if(attr.type == "date")
							{
								rule.type = "custom-component"
								rule.is_date = true
								
								rule.component = "date_picker" // b-form-datepicker"
								//rule["start-weekday"] = 1 // TODO
								//rule["date-format-options"] = { year: "numeric", month: "numeric", day: "numeric" } // TODO
								rule.operations["="] = "eqd"
								rule.operations["не равно"] = "neqd"
								rule.operations["<"] = "ltd"
								rule.operations[">"] = "gtd"
								rule.operations["<="] = "lted"
								rule.operations[">="] = "gted"
							}
							else if(attr.type == "time")
							{
								rule.type = "custom-component"

								rule.component = "b-form-timepicker"
								rule["show-seconds"] = true // TODO

								rule.operations["="] = "eqt"
								rule.operations["<"] = "ltt"
								rule.operations[">"] = "gtt"
								rule.operations["<="] = "ltet"
								rule.operations[">="] = "gtet"
							}
							else if(attr.type == "datetime")
							{
								rule.type = "custom-component"

								rule.component = "datetime_picker"
								rule.component_config =
									{
										format : "DD.MM.YYYY HH:mm",
										locale : "ru",
										sideBySide : true,
										icons :
										{
											time : "far fa-clock",
											date : "far fa-calendar",
											up : "fas fa-arrow-up",
											down : "fas fa-arrow-down",
											previous : "fas fa-chevron-left",
											next : "fas fa-chevron-right",
											today : "fas fa-calendar-check",
											clear : "far fa-trash-alt",
											close : "far fa-times-circle"
										}
									}

								rule.operations["="] = "eqdt"
								rule.operations["<"] = "ltdt"
								rule.operations[">"] = "gtdt"
								rule.operations["<="] = "ltedt"
								rule.operations[">="] = "gtedt"
							}
						}
							
						rule.operators = Object.keys(rule.operations)

						rules.push(rule)
					}))
		})
		
	return Promise.all(promises).then(() =>
	{
		api.sort_objects_array_by_key(rules, "label")
	
		return rules
	})
}

function compile_query(rules, raw, key_prefix = null, exceptions_for_key_prefix = [])
{
	var query = []

	if(raw["children"])
		raw["children"].forEach(
			elem =>
			{
				if(elem.type == "query-builder-group")
					query.push(compile_query(rules, elem.query, key_prefix))
				else if(elem.query.rule == "filter")
					query.push({ keys : [ "filter" ], operation : "filter", args : [ elem.query.value ]}) 
				else if(elem.query.rule == "protocol" || elem.query.rule == "document" || elem.query.rule == "cadastral_group" || elem.query.rule == "cadastral_group_exactly" || elem.query.rule == "cadastral_group_children" || elem.query.rule == "cadastral_group_right" || elem.query.rule == "cadastral_group_bad" || elem.query.rule == "average_cost_group")
					query.push({ keys : [ elem.query.rule ], operation : elem.query.rule, args : elem.query.value })
				else
				{
					const rule = rules.find(rule => rule.id == elem.query.rule)
					const operation = rule.operations[elem.query.operator]
					var value = elem.query.value
					var keys

					if(key_prefix)
					{
						keys = []

						rule.keys.forEach(
							key =>
							{
								if(exceptions_for_key_prefix.includes(key))
									keys.push(key)
								else
									keys.push(key_prefix + key)
							})
					}
					else
						keys = rule.keys

					query.push({ keys : keys, operation : operation, args : [ value ], reference : rule.reference })
				}
			})

	if(query.length == 0)
		return {}

	if(raw.logicalOperator == "all")
		return { "and" : query }
	else if(raw.logicalOperator == "any")
		return { "or" : query }
	else if(raw.logicalOperator == "not_all")
		return { "nor" : query }
	
	return { "or" : query }
}

function load_rule(rules, condition, query_key_prefix)
{
	if(Object.keys(condition).length == 0)
		return { query : { logicalOperator : "all", children : [] } }

	if(condition.and || condition.or || condition.nor)
	{
		var key = "or"
		var operator = "any"
		var children = []

		if(condition.and)
		{
			key = "and"
			operator = "all"
		}
		else if(condition.nor)
		{
			key = "nor"
			operator = "not_all"
		}

		condition[key].forEach(child_condition => children.push(load_rule(rules, child_condition, query_key_prefix)))

		return {

			type : "query-builder-group",
			query :
			{
				logicalOperator : operator,
				children : children
			}

		}
	}

	var condition_key

	if(query_key_prefix)
		condition_key = condition.keys[0].replace(query_key_prefix, "")
	else
		condition_key = condition.keys[0]

	const rule = rules.find(rule => rule.keys.includes(condition_key)) // TODO Сравнение массивов
	const op = Object.keys(rule.operations).find(key => rule.operations[key] == condition.operation)
	var value

	// TODO Редкостный костыль - где-то в коде value интерпретируется как одно значение, а не как массив, как должно
	if(condition.args.length == 1)
		value = condition.args[0]
	else
		value = condition.args

	return {

		type : "query-builder-rule",
		query :
		{
			rule : rule.id,
			operator : op,
			operand : rule.label,
			value : value,
		}

	}
}

function load(rules, filter, query_key_prefix)
{
	return load_rule(rules, JSON.parse(filter), query_key_prefix).query
}

function check(self)
{
	if(self.$refs.query.$el.getElementsByClassName("invalid-feedback d-block").length)
		return false

	return true
}

export default
{
	labels,

	create_rules,
	compile_query,
	load,
	check,
}

